/**
 * Pure normaliser for admin-defined custom size presets.
 *
 * Lives in its own tiny module (no React, no network) so unit tests
 * can import it without pulling `lib/store.js` → axios ESM into the
 * Jest sandbox.
 *
 * The React hook that fetches the raw list from /settings lives in
 * `customSizePresets.js` and delegates to this function.
 */
import { convertSizeToSqFt } from './helpers';


export function normalizeSizePresets(rawPresets, existingValues = []) {
  if (!Array.isArray(rawPresets)) return [];
  const seen = new Set(existingValues.map(v => (v || '').toString().toLowerCase()));
  const out = [];
  for (const raw of rawPresets) {
    if (typeof raw !== 'string') continue;
    const s = raw.trim().toLowerCase().replace(/\s+/g, '');
    if (!s || !s.includes('x')) continue;
    if (seen.has(s)) continue;
    const sqft = convertSizeToSqFt(s, 'feet');
    if (!(sqft > 0)) continue;
    const [len, wid] = s.split('x');
    out.push({
      label: `${len} × ${wid}`,
      value: s,
      sqft,
      isCustom: true,
    });
    seen.add(s);
  }
  return out;
}
